import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { Navigate } from "react-router-dom";
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';
import moment from 'moment';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import { APIURL, DownloadCV, GetDynamicFormPreview, GetSubmittedFormPreview, PreviewCV } from '../../services/axiosServices/ApiEndPoints';
import { createRef } from 'react';

export default class SafeguardingForm extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.dt = createRef();
        this.state = {
            safeguardingList: [],
            route: null,
            isLoading: false,
            dateRange: null,
            totalRecords: 0,
            filterDetails: {
                start: 0,
                length: 50,
                search: '',
                sortField: '',
                sortOrder: 'asc',
                startDate: '',
                endDate: '',
            }
        };
        this.exportCSV = this.exportCSV.bind(this);
        this.exportPdf = this.exportPdf.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.saveAsExcelFile = this.saveAsExcelFile.bind(this);

    }

    componentDidMount() {
        this.safeguardingForms();
    }

    safeguardingForms = () => {
        let filterDetials = this.state.filterDetails;
        this.setState({ isLoading: true })
        let request = [
            filterDetials.start,
            filterDetials.length,
            filterDetials.search,
            filterDetials.sortField,
            filterDetials.sortOrder,
            filterDetials.startDate && Number(moment(filterDetials.startDate).format('YYYYMMDD')),
            filterDetials.endDate && Number(moment(filterDetials.endDate).format('YYYYMMDD')),
        ];
        this.adminServices.safeguardingForm(request).then((response) => {
            if (response && response.data && response !== null) {
                let res = response?.data || [];
                const total = response?.totalRecords || 0;

                res.map((x, index) => {
                    x.srNo = index + 1
                })

                this.setState({
                    safeguardingList: res,
                    totalRecords: total,
                    isLoading: false
                });
            }
        });

    }

    handleSearch = (value) => {
        let details = this.state.filterDetails
        details.search = value;
        this.setState({ filterDetails: details }, () => {
            this.safeguardingForms();

        });
    }

    handleChangeDateRange = (value) => {
        let details = this.state.filterDetails

        if (value[0]) {
            details.startDate = value[0];
            details.startDate = details.startDate.setHours(0, 0, 0, 0);
        }

        if (value[1]) {
            details.endDate = value[1];
            details.endDate = details.endDate.setHours(23, 59, 59, 999);
        }
        this.setState({ filterDetails: details, dateRange: value }, () => {
            if (this.state.filterDetails.startDate && this.state.filterDetails.endDate) {
                this.safeguardingForms();
            }

        });
    }

    resetFilter = () => {
        let details = this.state.filterDetails
        details.search = '';
        details.startDate = '';
        details.endDate = '';
        this.setState({ filterDetails: details, dateRange: null }, () => {
            this.safeguardingForms()
        });
    }

    onPageChange = (event) => {
        let details = this.state.filterDetails
        details.start = event.first;
        details.length = event.rows;
        this.setState({ filterDetails: details }, () => {
            this.safeguardingForms();
        })
    };

    onSortChange = (event) => {
        const filterDetails = { ...this.state.filterDetails };
        filterDetails.sortField = event.sortField;
        filterDetails.sortOrder = event.sortOrder === 1 ? 'asc' : 'desc';
        this.setState({ filterDetails }, () => {
            this.safeguardingForms();
        });
    };

    actionBodyTemplate = (rowData) => {
        return (
            <div className="flex gap-2 justify-center">
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handlePreviewPDF(rowData)}
                    tooltip="Preview PDF"
                    tooltipOptions={{ position: 'top' }}
                />
                <Button
                    icon="pi pi-download"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleDownloadPDF(rowData)}
                    tooltip="Download PDF"
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );
    };

    handlePreviewPDF = async (rowData) => {
        const formId = rowData.id;
        const loginUser = getAuthProps();
        const token = loginUser.token;

        let url = "";
        if (rowData.isdynamic) {
            url = `${APIURL}${GetDynamicFormPreview}/${formId}/0`;

        } else {
            url = `${APIURL}${GetSubmittedFormPreview}/${formId}/0`;
        }

        try {
            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok === true) {
                const blob = await response.blob();
                const fileURL = URL.createObjectURL(blob);
                window.open(fileURL, '_blank');
            } else {
                this.swalServices.Error('File not found')
            }
        } catch (err) {
            console.error('Error opening PDF', err);
        }
    };

    handleDownloadPDF = async (rowData) => {
        const formId = rowData.id;
        const loginUser = getAuthProps();
        const token = loginUser.token;

        let url = "";
        if (rowData.isdynamic) {
            url = `${APIURL}${GetDynamicFormPreview}/${formId}/1`;

        } else {
            url = `${APIURL}${GetSubmittedFormPreview}/${formId}/1`;
        }

        try {
            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok === true) {
                const blob = await response.blob();
                const downloadUrl = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = downloadUrl;

                let filename = rowData.formname;
                link.download = filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(downloadUrl);
            } else {
                this.swalServices.Error('File not found')
            }
        } catch (err) {
            console.error('Download failed', err);
        }
    };

    // exportCSV(selectionOnly) {
    //     if (this.dt.current) {
    //         this.dt.current.exportCSV({ selectionOnly });
    //     }
    // }

    exportCSV(selectionOnly) {
        if (this.dt.current) {
            const data = selectionOnly ? this.dt.current.props.value.filter(row => this.dt.current.isSelected(row)) : this.dt.current.props.value;

            let csv = '';
            let columns = this.dt.current.props.children;

            columns = columns.filter(col => col.props.header !== 'Actions');
            csv += columns.map(col => col.props.header).join(',') + '\n';

            data.forEach(rowData => {
                const row = columns.map(col => {
                    const field = col.props.field;
                    return '"' + (rowData[field] !== undefined ? rowData[field] : '') + '"';
                });
                csv += row.join(',') + '\n';
            });

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const filename = 'Safeguarding Submission.csv';

            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                const url = URL.createObjectURL(blob);
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    getExportColumns() {
        return this.state.safeguardingList.map((col) => ({ title: 'ABC', dataKey: 'XYZ' }));
    }

    exportPdf() {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                const exportColumns = this.getExportColumns();
                doc.autoTable(exportColumns, this.state.safeguardingList);
                doc.save('Safeguarding Submission.pdf');
            });
        });
    }

    saveAsExcelFile(buffer, fileName) {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], { type: EXCEL_TYPE });

                module.default.saveAs(data, "Safeguarding Submission" + EXCEL_EXTENSION);
            }
        });
    }

    exportExcel() {
        import('xlsx').then((xlsx) => {
            const modifiedData = this.state.safeguardingList.map(({ formid, ...rest }) => {
                const { srNo, ...others } = rest;
                return { srNo, ...others };
            });

            const worksheet = xlsx.utils.json_to_sheet(modifiedData);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

            this.saveAsExcelFile(excelBuffer, 'safeguardingList');
        });
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }

        const pageSizes = [5, 10, 20, 50, 100];
        let rowsPerPageOptions = pageSizes.filter(size => size < this.state.totalRecords);

        if (!rowsPerPageOptions.includes(this.state.totalRecords)) {
            rowsPerPageOptions.push(this.state.totalRecords);
        }

        const paginatorRight = (
            <div className="flex gap-2">
                <Button label="Export CSV" icon="pi pi-file" className="export-btn" onClick={() => this.exportCSV(false)} />
                {/* <Button label="Export PDF" icon="pi pi-file-pdf" className="export-btn" onClick={this.exportPdf} /> */}
                <Button label="Export Excel" icon="pi pi-file-excel" className="export-btn" onClick={this.exportExcel} />
            </div>
        );

        return (
            <div className='user-lists'
                style={{ height: "calc((100dvh / 0.85) - 60.8px)" }}
            >
                <div className='user-lists-inner p-[30px]'>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>Safeguarding Submissions</h1>
                    </div>
                    <div className='user-table p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                        <div className='table-inner grid grid-cols-3 gap-5 items-end'>
                            <div className="input-grp !mb-0">
                                <label>
                                    Search
                                </label>
                                <InputText
                                    type="search"
                                    value={this.state.globalFilter}
                                    onChange={(e) => this.handleSearch(e.target.value)}
                                    placeholder="Search across all columns..."
                                />
                            </div>
                            <div className="input-grp !mb-0">
                                <label>
                                    Filter by Date Range
                                </label>
                                <Calendar
                                    value={this.state.dateRange}
                                    onChange={(e) => this.handleChangeDateRange(e.value)}
                                    selectionMode="range"
                                    placeholder="Select date range"
                                    dateFormat="yy-mm-dd"
                                    readOnlyInput
                                    numberOfMonths={2}
                                    maxDate={new Date()}
                                    style={{ height: "42px" }}
                                />
                            </div>
                            <Button
                                label="Reset filters"
                                className='w-fit h-fit'
                                onClick={() => this.resetFilter()}
                                style={{ fontWeight: "400", lineHeight: "1" }}
                            />
                        </div>
                        <div className="sub-table rounded-xl shadow-sm overflow-hidden border border-gray-200 bg-white mt-[30px]">
                            <div style={{ overflowX: 'auto' }}>
                                <div style={{ minWidth: '1800px' }}> {/* Add large minWidth here for scrolling */}
                                    <DataTable
                                        value={this.state.safeguardingList}
                                        paginator
                                        lazy
                                        first={this.state.filterDetails.start}
                                        rows={(this.state.totalRecords > this.state.filterDetails.length) ? this.state.filterDetails.length : this.state.totalRecords}
                                        totalRecords={this.state.totalRecords}
                                        onPage={(e) => this.onPageChange(e)}
                                        rowsPerPageOptions={rowsPerPageOptions}
                                        responsiveLayout="scroll"
                                        scrollable
                                        scrollHeight="calc((100dvh / 0.85) - 360px)"
                                        className="min-w-full"
                                        emptyMessage="No data found"
                                        loading={this.state.isLoading}
                                        loadingIcon={
                                            <div className="flex justify-center items-center w-full py-4">
                                                <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                            </div>
                                        }
                                        onSort={(e) => this.onSortChange(e)}
                                        sortField={this.state.filterDetails.sortField}
                                        sortOrder={this.state.filterDetails.sortOrder === 'asc' ? 1 : -1}
                                        paginatorRight={paginatorRight}
                                        ref={this.dt}
                                    >
                                        <Column
                                            field="srNo"
                                            header="Sr No"
                                            body={(rowData, options) => options.rowIndex + 1}
                                            filterPlaceholder="Search by ID"
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                        <Column
                                            field="name"
                                            header="Name"
                                            sortable
                                            filterPlaceholder="Search by name"
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                        <Column
                                            field="relation"
                                            header="Relation"
                                            sortable
                                            filterPlaceholder="Search by relation"
                                            // filterFunction={this.filterByDateRange}
                                            // filterElement={this.dateRangeFilterTemplate}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                        <Column
                                            field="contact"
                                            header="Contact"
                                            sortable
                                            filterPlaceholder="Search by contact"
                                            // filterFunction={this.filterByDateRange}
                                            // filterElement={this.dateRangeFilterTemplate}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                        <Column
                                            field="personatrisk"
                                            header="Person at Risk"
                                            sortable
                                            filterPlaceholder="Search by personatrisk"
                                            // filterFunction={this.filterByDateRange}
                                            // filterElement={this.dateRangeFilterTemplate}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                        <Column
                                            field="incidentdate"
                                            header="Incident Date"
                                            sortable
                                            filterPlaceholder="Search by incidentdate"
                                            // filterFunction={this.filterByDateRange}
                                            // filterElement={this.dateRangeFilterTemplate}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                        <Column
                                            field="locationservice"
                                            header="Location/Service"
                                            sortable
                                            filterPlaceholder="Search by location/service"
                                            // filterFunction={this.filterByDateRange}
                                            // filterElement={this.dateRangeFilterTemplate}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                        <Column
                                            field="details"
                                            header="Details"
                                            sortable
                                            filterPlaceholder="Search by details"
                                            style={{ width: "400px" }}
                                            bodyStyle={{ whiteSpace: 'pre-wrap' }}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                        <Column
                                            field="hasreported"
                                            header="Has Reported"
                                            sortable
                                            filterPlaceholder="Search by hasreported"
                                            // filterFunction={this.filterByDateRange}
                                            // filterElement={this.dateRangeFilterTemplate}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                        <Column
                                            field="reportdetails"
                                            header="Report Details"
                                            sortable
                                            filterPlaceholder="Search by reportdetails"
                                            style={{ width: "400px" }}
                                            bodyStyle={{ whiteSpace: 'pre-wrap' }}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                        <Column
                                            field="createddate"
                                            header="Submitted Date"
                                            sortable
                                            filterPlaceholder="Search by createddate"
                                            headerClassName="bg-blue-50 text-blue-800 font-medium">
                                        </Column>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}